import { Observable, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { ContactUs } from '../models/contact-us';
import { BaseService } from '../base/base-service';
import { GetAlertsPayload } from '../models/get-alerts';


@Injectable({
  providedIn: 'root'
})
export class GetAlertsService extends BaseService {

  readonly uris = {
    getAlerts: `api/${environment.api.version}/get-alerts`,
  };



  getAlertsPost(request: GetAlertsPayload): Observable<any> {
    return this.http
      .post<any>(this.getUrl(`${this.uris.getAlerts}`, false), request)
      .pipe(
        switchMap(response => {
          return [response];
        }),
        catchError(error => {
          return [null];
        })
      );
  }
}
